// Default
import '../../custom/js/default';

////needed for pagebuilder
//import 'bootstrap/js/dist/util';
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/tooltip';

//// JS
//import '../../custom/js/indexOptimized';
//import Hero from '../../custom/js/components/hero'; 

////Pagebuilder JS
//import '../../custom/js/components/pagebuilder';
//import '../../custom/js/components/accordion';

//// Base SCSS
//import '../../custom/scss/style.scss';

//$(() => {
//	const hero = new Hero();
//	hero.init();
//});